import Vue from 'vue'
import VueRouter from 'vue-router'
import store from 'store'
import { getterTypes } from 'store/auth'

Vue.use(VueRouter)

const routes = [
  { path: '/login', name: 'Login', component: () => import('views/Login.vue') },
  { path: '/logout', name: 'Logout', component: () => import('views/Logout.vue') },
  {
    path: '/',
    name: 'Dashboard',
    component: () => import('views/Dashboard.vue'),
    meta: { auth: true },
  },
  {
    path: '/measurements',
    name: 'Measurements',
    component: () => import('views/Measurements.vue'),
    meta: { auth: true },
  },
  {
    path: '/score',
    name: 'Score',
    component: () => import('views/Score.vue'),
    meta: { auth: true },
  },
  {
    path: '/measurements/:uuid',
    name: 'MeasurementDetail',
    component: () => import('views/MeasurementDetail.vue'),
    meta: { auth: true },
  },
  {
    path: '/suitability',
    name: 'Suitability',
    component: () => import('views/Suitability.vue'),
    meta: { auth: true },
  },
  { path: '*', name: 'NotFound', component: () => import('views/NotFound.vue') },
]

const router = new VueRouter({
  mode: 'history',
  routes,
})

// Global auth guard — waits for a pending restore, then gates protected routes.
router.beforeEach(async (to, from, next) => {
  if (store.getters[getterTypes.status] === 'loading') {
    await new Promise(resolve => {
      const unwatch = store.watch(
        s => s.auth.status,
        status => {
          if (status !== 'loading') {
            unwatch()
            resolve()
          }
        }
      )
    })
  }

  if (to.meta && to.meta.auth && store.getters[getterTypes.isLoggedIn] !== true) {
    return next({ name: 'Login', query: { redirect: to.fullPath } })
  }
  if (to.name === 'Login' && store.getters[getterTypes.isLoggedIn] === true) {
    return next({ name: 'Dashboard' })
  }
  return next()
})

export default router
